import { get } from 'lodash';

const styles = ({ color }) => ({
  submitButton: {
    backgroundColor: `${get(color, 'error')} !important`,
    borderColor: `${get(color, 'error')} !important`,
    '&:hover': {
      borderColor: `${get(color, 'error')} !important`,
    },
    '&:focus': {
      borderColor: `${get(color, 'error')} !important`,
    },
  },
  deleteButton: {
    borderColor: get(color, 'error'),
    color: get(color, 'error'),
    '&:hover': {
      borderColor: get(color, 'errorHover'),
    },
    '&:focus': {
      borderColor: get(color, 'error'),
      outlineWidth: '1px !important',
      outlineOffset: '-4px !important',
      outlineStyle: 'solid !important',
      outlineRadius: '3px !important',
      outlineColor: get(color, 'error'),
    },
  },
});

export default styles;
